import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

export default function useGetFilteredByWhatDestinations(preselectedWhat) {
  const { what, where } = useSelector((state) => state.mainFilter.searchEngine);
  const [destinations, setDestinations] = useState(where.destinations);
  const [destinationsGroups, setDestinationsGroups] = useState(
    where.destinationsGroups
  );

  useEffect(() => {
    const whatTypes = preselectedWhat ? preselectedWhat : what.filter(({ active }) => active).map(({ id }) => id);
    const filterByType = (data, whatTypes) => (
      data.map((item) => {
        if (item.types === '' || item.types.length === 0)
          return { ...item, hideByType: true };
        return item.types.filter((type) => whatTypes.includes(type)).length > 0
          ? { ...item, hideByType: false }
          : { ...item, hideByType: true };
      })
    )

    const filterByEachType = (data) =>
      whatTypes.map((id) => {
        return filterByType(data, [id]).filter(({ hideByType }) => !hideByType)
          .length;
      });

    if (whatTypes.length === 0) {
      setDestinations(
        where.destinations.map((item) => ({ ...item, hideByType: false }))
      );
      setDestinationsGroups(
        where.destinationsGroups.map((item) => ({ ...item, hideByType: false }))
      );
      return;
    }

    const destinationsForEachType = filterByEachType(destinations);
    const destinationsGroupsForEachType = filterByEachType(destinationsGroups);
    const isEmptyDestinationByType = destinationsForEachType.includes(0);
    const isEmptyDestinationGroupsByType =
      destinationsGroupsForEachType.includes(0);

    const filteredDestinations = filterByType(where.destinations, whatTypes);
    const filteredDestinationsGroups = filterByType(
      where.destinationsGroups,
      whatTypes
    ).filter(({ id }) =>
      filteredDestinations.some(({ destinations_groups }) =>
        destinations_groups.includes(id)
      )
    );


    setDestinations(
      isEmptyDestinationByType
        ? where.destinations.map((item) => ({ ...item, hideByType: false }))
        : filteredDestinations
    );
    setDestinationsGroups(
      isEmptyDestinationGroupsByType
        ? where.destinationsGroups.map((item) => ({
            ...item,
            hideByType: false,
          }))
        : filteredDestinationsGroups
    );
  }, [where.destinations, where.destinationsGroups, what, preselectedWhat]);

  return {
    destinations,
    setDestinations,
    destinationsGroups,
    setDestinationsGroups,
  };
}
